/* Поле карточек GitLab: подпись капсом и значение (как в «О кластере»). */
import { ReactNode } from 'react';
import { Grid, Typography, makeStyles } from '@material-ui/core';

export const useFieldStyles = makeStyles(theme => ({
  label: {
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: '0.06em',
    textTransform: 'uppercase',
    color: theme.palette.text.secondary,
    marginBottom: 2,
  },
  value: { fontSize: 14, overflowWrap: 'anywhere' },
  mono: { fontFamily: 'ui-monospace, Menlo, monospace', fontSize: 13 },
  muted: { color: theme.palette.text.secondary },
  chips: { display: 'flex', flexWrap: 'wrap', gap: 6 },
}));

export const Field = ({
  label,
  children,
  full,
}: {
  label: string;
  children: ReactNode;
  full?: boolean;
}) => {
  const classes = useFieldStyles();
  return (
    <Grid item xs={12} sm={full ? 12 : 6}>
      <Typography className={classes.label}>{label}</Typography>
      <div className={classes.value}>{children}</div>
    </Grid>
  );
};
